import { defineStore } from 'pinia';
import { computed } from '#imports';

export const usePreviewStore = defineStore('preview', () => {
  const previewRoleId = useCookie<number | null>('xf-preview-role', {
    default: () => null,
  });

  const isPreviewing = computed<boolean>(() => previewRoleId.value !== null);

  const setRole = (roleId: number): void => {
    previewRoleId.value = roleId;
  };

  const clear = (): void => {
    previewRoleId.value = null;
  };

  return {
    previewRoleId,
    isPreviewing,
    setRole,
    clear,
  };
});
